import React from 'react';
import LeftSide from './components/LeftSide';
import Middle from './components/Middle';
import Nav from './components/Nav';
import Rightside from './components/Rightside';

const App = () => {
  return (
    <>
      <Nav />

      <div
        className="w3-container w3-content"
        style={{ maxWidth: 1400, marginTop: 80 }}
      >
        <div className="w3-row">
          <LeftSide />
          <Middle />
          <Rightside />
        </div>
        <br />

        <br />

        <div className="w3-card w3-round w3-white w3-padding-32 w3-center middle_icons">
          <span className="code-icons">
            <i className="fa fa-css3 w3-xxlarge"></i>
          </span>
          <span className="code-icons">
            <i className="fa fa-file-code-o w3-xxlarge"></i>
          </span>
          <span className="code-icons">
            <i className="fa fa-html5 w3-xxlarge"></i>
          </span>
        </div>
      </div>

      <br />

      <footer className="w3-container codes_items w3-padding-16 w3-center middle_icons">
        <div className="social-icons">
          <span className="icons">
            <i className="fa fa-instagram w3-xlarge" aria-hidden="true"></i>
          </span>
          <span className="icons">
            <a
              href="https://www.linkedin.com/in/pislaru-g-316205231/"
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="fa fa-linkedin-square w3-xlarge"
                aria-hidden="true"
              ></i>
            </a>
          </span>

          <span className="icons">
            <i
              className="fa fa-twitter-square w3-xlarge"
              aria-hidden="true"
            ></i>
          </span>
        </div>
      </footer>

      <footer className="w3-container last_footer">
        <p className="desc">
          Powered by
          <a
            className="copy"
            href="mailto:icreateandbuild@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            &copy; I-CREATE -
          </a>{' '}
          {new Date().getFullYear()}
        </p>
      </footer>
    </>
  );
};

export default App;
